import React from 'react'
import {Col, Container, Form, Row} from "react-bootstrap";
import {Multiselect} from 'multiselect-react-dropdown';
import EditRolesForm from "./EditRolesForm";
import {ContactForm, EmailForm, FirstNameForm, LastNameForm} from "./NameForm";
import "../../Styles/BenutzerManagement/EditRolesForm.css"
import EditBusinessRolesForm from "./EditBusinessRolesForm";

const UserModal = (elem) => {
    return (

        <Container>
            <br/>
            <Row>
                <Col>
                    <Form.Group as={Row}
                                controlId="formEditGender">
                        <Form.Label column sm="3">Geschlecht:</Form.Label>
                        <Col>
                            <Multiselect className="chip multiSelectContainer optionContainer searchBox"
                                         options={elem.props.availableGender}
                                         placeholder="M/ W/ D"
                                         selectedValues={elem.props.userGender}
                                         onSelect={elem.onSelectedGenderChange}
                                         onRemove={elem.onSelectedGenderChange}
                                         displayValue="gender"
                                         showCheckbox="True"
                                         singleSelect="True"
                                         avoidHighlightFirstOption="True"
                            /><p className="editFormColColor">{elem.props.errorMessageGender}</p>
                        </Col>
                    </Form.Group>
                </Col>
            </Row>

            <Row>
                <Col>
                    <Form.Group as={Row} controlId="formEditFirstName">
                        <FirstNameForm defaultvalue={elem.props.editUserData.items.fn} props={elem.props}
                                       data={elem.props.editUserData} changeState={elem.updateNameForm}/>
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col>

                    <Form.Group as={Row} controlId="formEditLastName">
                        <LastNameForm defaultvalue={elem.props.editUserData.items.ln} props={elem.props}
                                      data={elem.props.editUserData} changeState={elem.updateNameForm}/>
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col>

                    <Form.Group as={Row} controlId="formEditEmail">
                        <EmailForm defaultvalue={elem.props.editUserData.items.em} props={elem.props}
                                   data={elem.props.editUserData}
                                   current_em={elem.props.editUserData.items.em} changeState={elem.updateNameForm}
                                   setupCompanyEmail={false}/>
                    </Form.Group>
                </Col>

            </Row>

            <Row>
                <Col>
                    <Form.Group as={Row} controlId="formEditContact">
                        <ContactForm defaultvalue={elem.props.editUserData.items.co} props={elem.props}
                                     data={elem.props.editUserData}
                                     initialContact={elem.props.initialContact} changeState={elem.updateNameForm}/>
                    </Form.Group>
                </Col>
            </Row>
            {elem.props.loggedInUser === 'superAdmin' && elem.usermodal === 'NewUserModal' &&
            <Row>
                <Col>
                    <Form.Group as={Row}
                                controlId="formEditCompanyName">
                        <Form.Label column sm="3">Firmenname:</Form.Label>
                        <Col>
                            <Multiselect className="chip multiSelectContainer optionContainer searchBox"
                                //options={elem.props.availableCompanyNames}
                                         options={elem.props.availableCompanyNames.sort((i, j) => i.companyName.toLowerCase() > j.companyName.toLowerCase() ? 1 : -1)}
                                         placeholder="Wählen Sie eine Option"
                                         selectedValues={elem.props.userCompanyName}
                                         onSelect={elem.onSelectedCompanyChange}
                                         onRemove={elem.onSelectedCompanyChange}
                                         displayValue="companyName"
                                         showCheckbox="True"
                                         singleSelect="True"
                                         avoidHighlightFirstOption="True"
                            /><p className="editFormColColor">{elem.props.errorMessageCompany}</p>
                        </Col>
                    </Form.Group>
                </Col>
            </Row>
            }
            {elem.props.displayRoles &&
            <Row>
                <Col>
                    <EditRolesForm props={elem.props}
                                   onSelectedGenderChange={elem.onSelectedGenderChange}
                                   onSelectedRoleChange={elem.onSelectedRoleChange}
                    />
                </Col>
            </Row>
            }
            <Row>
                <Col>
                    <EditBusinessRolesForm props={elem.props}
                                           onSelectedBusinessRoleChange={elem.onSelectedBusinessRoleChange}
                    />
                </Col>
            </Row>
        </Container>

    )
};

export default UserModal